import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import gt from "../../images/gt.svg";
import gamstop from "../../images/gamstop.svg";
import gamcare from "../../images/gamcare.svg";
import raig from "../../images/raig.svg";
import begamble from "../../images/begambleaware.svg";

const Footer = () => {
  return (
    <footer className="lottolegenda-footer pad">
      <div className="lottolegenda-footer__grid">
        <div className="lottolegenda-footer__grid-part">
          <p className="lottolegenda-footer__header lottolegenda-footer__header-age">
            Age Restriction Notice
          </p>
          <p className="t-12">
            Vikinglotto is strictly available to individuals aged 18 or over.
            <br></br>Participation by minors is prohibited by law in all
            participating countries.<br></br>We are committed to promoting
            responsible gaming and protecting underage individuals from exposure
            to gambling activities.<br></br>Please play responsibly and seek
            support if you feel your gaming habits are becoming problematic.
          </p>
        </div>
        <div className="lottolegenda-footer__grid-part">
          <p className="lottolegenda-footer__header">Responsible Gaming</p>
          <p className="t-12">
            At Vikinglotto, we believe that playing the lottery should always be
            fun, safe, and under control.
            <br></br>We are fully committed to promoting responsible gaming
            practices and protecting players from the risks associated with
            problem gambling.
          </p>
        </div>
      </div>
      <ul className="lottolegenda-footer__logos">
        <Link to="https://www.gamblingtherapy.org/">
          <img
            src={gt}
            title="Gambling Therapy - Practical advice and support for problem gambling"
            alt="Gambling Therapy"
          />
        </Link>
        <Link to="https://www.gamstop.co.uk/">
          <img
            src={gamstop}
            title="GAMSTOP - Gambling Self-Exclusion Scheme"
            alt="GAMSTOP"
          />
        </Link>
        <Link to="https://www.gamcare.org.uk">
          <img
            src={gamcare}
            title="GamCare is a leading provider of support services for all"
            alt="GamCare"
          />
        </Link>
        <Link to="https://www.raig.org/">
          <img
            src={raig}
            title="Raig – Responsible Affiliates in Gambling"
            alt="Raig"
          />
        </Link>
        <Link to="https://www.gambleaware.org/">
          <img
            src={begamble}
            title="GambleAware: Gambling Help & Gambling Addiction"
            alt="GambleAware"
          />
        </Link>
      </ul>
      <div className="lottolegenda-footer__bottom">
        <div className="lottolegenda-footer__policy">
          <Link to="/responsible-gaming">Responsible Gaming</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies">Cookies</Link>
        </div>
        <div className="lottolegenda-footer__policy">
          <Link to="/">Home</Link>
          <Link to="/how-to-play">How to play</Link>
          <Link to="/results">Draw results</Link>
          <Link to="/winners">Winners</Link>
          <Link to="/about">About the lottery</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
